import { render, staticRenderFns } from "./StockValueList.vue?vue&type=template&id=8bdcf8d0&scoped=true"
import script from "./StockValueList.vue?vue&type=script&lang=ts"
export * from "./StockValueList.vue?vue&type=script&lang=ts"
import style0 from "./StockValueList.vue?vue&type=style&index=0&id=8bdcf8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdcf8d0",
  null
  
)

export default component.exports